import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";
import {trackPromise} from "react-promise-tracker";

export const createUser = (payload) => {
  const url = getUrl("listUser");
  return trackPromise(Call.post(url, payload));
};

export const getUsers = (pageUrl) => {
  const url = pageUrl ? pageUrl : getUrl("listUser");
  return trackPromise(Call.get(url));
};

export const editUser = (data = {}) => {
  const {id = ""} = data;
  const url = getUrl("listUser");
  const patchUrl = `${url}${id}/`;
  return trackPromise(Call.patch(patchUrl, data));
};

export const deleteUser = (id = "") => {
  const url = getUrl("listUser");
  const patchUrl = `${url}${id}/`;
  return trackPromise(Call.delete(patchUrl));
};

export const getUserProfileAsync = () => {
  const url = getUrl("profile");
  return trackPromise(Call.get(url));
};

export const verifyPhoneNumberAsync = (payload) => {
  const url = getUrl("verifyPhone");
  return trackPromise(Call.post(url, payload));
};
